module.exports = __webpack_public_path__ + "1b0a4409e1ffd50dcf73b15ed19e4d86.otf";